import axios from "axios";
import { API_URL, getHeaders } from "../config";

/**
 * The learner's own "My Learning Plan" — content individually assigned to them,
 * with completion status derived server-side from existing telemetry.
 * Additive: this never affects the role-based catalog the learner already sees.
 */
export const getMyAssignments = async () => {
  try {
    const { data } = await axios.get(`${API_URL}/api/assignment/me`, {
      headers: getHeaders().headers,
    });
    return data?.data ?? [];
  } catch (error) {
    const status = error?.response?.status;
    if (status === 401 || status === 403) {
      localStorage.removeItem("token");
      window.location.href = "/";
    }
    return [];
  }
};
